import React from "react";
import { translate as t } from "../../../../infrastructure/translate/localization";
import ButtonAction from "../../../../app/components/commons/buttonAction/ButtonAction";

import "./loading-card.scss";
import { redirect } from "../../../../app/routes/Routes";

import uploadingFileimg from "../../../../assets/img/uploading-file.svg";

function LoadingCard() {
  return (
    <div className="section-container loading-csv">
      <div className="thumbnail">
        <img src={uploadingFileimg} alt={t("common-messages.loading-data")} />
      </div>
      <div className="loading-csv-content">
        <div className="loading-csv-content-description">
          <p>{t("edit-employees.edit-employees-loading")}</p>
        </div>
      </div>
      <div className="buttons-group">
        <ButtonAction
          textButton={`${t("actions.go-to")} ${t(
            "my-account-section.my-account"
          )}`}
          textLoadingButton={t("common-messages.loading-data")}
          handlerClick={() => redirect("/my-account")}
        />
      </div>
    </div>
  );
}

export default LoadingCard;
